import { render, staticRenderFns } from "./BlockerTypeField.vue?vue&type=template&id=9496e3a2&scoped=true"
import script from "./BlockerTypeField.vue?vue&type=script&lang=js"
export * from "./BlockerTypeField.vue?vue&type=script&lang=js"
import style0 from "./BlockerTypeField.vue?vue&type=style&index=0&id=9496e3a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9496e3a2",
  null
  
)

export default component.exports